import { render, staticRenderFns } from "./client-info-tab.vue?vue&type=template&id=3fc93789&scoped=true"
import script from "./client-info-tab.vue?vue&type=script&lang=js"
export * from "./client-info-tab.vue?vue&type=script&lang=js"
import style0 from "./client-info-tab.vue?vue&type=style&index=0&id=3fc93789&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc93789",
  null
  
)

export default component.exports